import './pulse-indicator.style.sass';
import template from './pulse-indicator.tpl.pug';

export default {
    selector: 'dbPulseIndicator',
    template: template()
};



// WEBPACK FOOTER //
// ./src/common/component/loader/component/pulse-indicator/pulse-indicator.cmpt.js